import { ref, useContext } from "@nuxtjs/composition-api";
import { CollectionTypes } from '~/modules/collections/types';

export function useCollections() {
  const { app } = useContext();
  const loading = ref(false);
  const collections = ref<CollectionTypes>();
  const collection = ref();

  const loadCollections = async (collectionsType: string) => {

    try {
      loading.value = true;
      // @ts-ignore
      let response = await app.$vsf.$magento.api.collections({ collectionsType: collectionsType });
      collections.value = response?.data?.categoryCollectionTypes?.items || [];
    } catch (error) {
      console.warn('Error: ', error);
    } finally {
      loading.value = false;
    }

    return collections;
  };

  const loadCollection = async (collectionName: string) => {

    try {
      loading.value = true;
      // @ts-ignore
      let response = await app.$vsf.$magento.api.collection({ collectionName: collectionName });
      collection.value = response?.data?.categoryCollections?.items[0];
    } catch (error) {
      console.warn('Error: ', error);
    } finally {
      loading.value = false;
    }

    return collections;
  };

  return {
    loading,
    collections,
    loadCollections,
    collection,
    loadCollection
  }
}

export default useCollections;
